import { lazy } from 'react';

export const ReportsPageCatalogComplianceAsync = lazy(
    () => import('./ReportsPageCatalogCompliance'),
);
